<template>
  <div class="source">
    <div class="flex space-between">
      <h1 class="source__title">Источники <span class="source__count">{{total}}</span> </h1>
      <VButtonNew  @click="add" class="source__create" label="Новый источник" style-type="link">
        <template #iconLeft>
          <IconsPlus icon-size="20px" />
        </template>
      </VButtonNew>
    </div>

    <div class="source__wrapper">
      <main class="source__main">
        <h2 class="source__main-title">
          Список источников резюме
        </h2>
        <p class="source__main-description">
          Вы можете добавлять, редактировть и удалять источники резюме помимо первых трёх стандартных (Авито-отклик, HH-отклик, Из базы)
        </p>
        <div class="source__main-list source__list">
          <SettingsReasonElement
              v-if="!skeleton"
              v-for="(item, index) in currentReasons"
              :key="item.id"
              :data="item"
              @edit="onEditReason"
              @delete="openModalDelete"
          />
          <div v-if="skeleton" class="setting__block-option">
            <VSkeleton class="setting__block-option-block" variants="SETTINGS_REASONS" v-if="skeleton"/>
          </div>
        </div>
<!--        <button class="source__main-button" @click="addReason">-->
<!--          <IconsPlus />-->
<!--          <span class="source__main-button-text"-->
<!--          >Добавить причину</span-->
<!--          >-->
<!--        </button>-->
      </main>
    </div>
    <ModalWindow
        class="source__modal-poups"
        :showModalWithOverflow="showModalWindow"
        v-show="showModalWindow"
        @close="showModalWindow = false"
    >
      <VModalWrapper
          :title="currentItem?.id ? 'Изменить источник' : 'Новый источник'"
          :ok-btn-title="currentItem?.id ? 'Сохранить' : 'Добавить'"
          @close="showModalWindow = false" width="352px"
          @apply="apply">
        <VCustomInput
            class="source__input"
            placeholder="Название источника*"
            v-model="dataForm.source_name"
        />
<!--                    <p class="source__form-field-error" v-if="formErrors.reason">-->
<!--                      {{ formErrors.reason }}-->
<!--                    </p>-->
      </VModalWrapper>
    </ModalWindow>
    <ModalWindow
        class="source__modal-delete"
        :showModalWithOverflow="showModalDelete"
        v-show="showModalDelete"
        @close="showModalDelete = false"
    >
      <DeleteItems
          title="Удалить источник"
          :deleteIntegrationsName="deleteItem?.name"
          @close="showModalDelete = false"
          @delete="onDeleteReason"
      />
    </ModalWindow>
  </div>
</template>

<script setup>
import {ref, computed, onMounted} from "vue";
import sources from "@/api/sources";
import rejectionReasons from "@/api/rejectionReasons";
import SettingsReasonElement from "@/components/Settings/SettingsReasonElement";
import VSkeleton from "@/components/UI/VSkeleton/index.vue";
import IconsPlus from "@/components/Icons/Plus.vue";
import VButtonNew from "@/components/UI/VButtonNew/index.vue";
import VModalWrapper from "@/components/UI/VModalWrapper.vue";
import DeleteItems from "@/components/ModalWindow/ModalBodyes/DeleteItems.vue";
const skeleton = ref(true)
const dataItems = ref([]);

const dataForm = ref({
  source_name: "",
  id: null,
})
const showModalDelete = ref(false);
const showModalWindow = ref(false);
const currentItem = ref(null);
const currentModal = ref("");
const total = ref(0)
const currentReasons = computed(
    () => dataItems.value
);
const add = () => {
  dataForm.value = {
    source_name: "",
    id: null,
  }
  showModalWindow.value = true;
};

const apply = async () => {
  if (dataForm.value?.id) {
    await sources.editSources({name: dataForm.value.source_name}, currentItem.value?.id)
  } else {
    await sources.addSources({name: dataForm.value.source_name})
  }
  showModalWindow.value = false;
  dataForm.value = {
    source_name: "",
    id: null,
  }
  await getRejectionSources();
}

const onEditReason = (item) => {
  showModalWindow.value = true;
  if(item) {
    dataForm.value.source_name = item.name;
    dataForm.value.id = item.id;
  }
  currentItem.value = item;
};
const deleteItem = ref(null)
const openModalDelete = (item) => {
  deleteItem.value = item;
  showModalDelete.value = true;
}
const onDeleteReason = async () => {
  showModalDelete.value = false;
  await sources.deleteSources(deleteItem.value.id)
  await getRejectionSources();
};


const getRejectionSources = async () => {
  dataItems.value = await sources.getSources()
  total.value = dataItems.value?.length || 0
  skeleton.value = false;
};

onMounted(async () => {
  await getRejectionSources();
})

</script>

<style scoped lang="scss">
.source {

  width: 832px;

  &__create {
    margin-top: 16px;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: right;

  }

  &__title {
    margin-top: 28px;
    margin-bottom: 24px;
    font-weight: 700;
    font-size: 28px;
    line-height: 33.89px;
    letter-spacing: 0%;
    color: $dark;
  }

  &__count {
    font-weight: 700;
    font-size: 16px;
    color: $gray;
    line-height: 100%;
    letter-spacing: 0;
  }

  &__wrapper {
    display: flex;
    column-gap: 32px;
    align-items: flex-start;
  }
  &__aside {
    padding: 12px;
    width: 256px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 16px;
    flex-grow: 0;
  }
  &__aside-title {
    width: 232px;
    margin-top: 12px;
    margin-bottom: 12px;
    margin-left: 12px;
    font-weight: 600;
    font-size: 16px;
    line-height: 19.36px;
    letter-spacing: 0%;
    color: $dark;
  }
  &__aside-item {
    width: 232px;
    padding: 12px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: 0%;
    color: $dark;
    border-radius: 8px;
    cursor: pointer;

    &:not(:last-child) {
      margin-bottom: 4px;
    }
    &:hover {
      background-color: #f0f2f4;
    }

    &_active {
      background-color: #f0f2f4;
    }
  }
  &__main {
    width: 832px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 16px;
  }
  &__main-title {
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 20px;
    line-height: 24.2px;
    letter-spacing: 0%;
    color: $dark;
  }
  &__main-description {
    max-width: 528px;
    margin-bottom: 16px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: 0%;

    color: $gray;
  }
  &__main-button {
    padding: 4px;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    background-color: transparent;
    margin-right: auto;
    outline: none;
    border: none;
    color: $blue;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: 0%;
    text-align: right;
    cursor: pointer;
  }
  &__main-button-icon {
    margin-right: 4px;
  }
  &__list {
    padding-top: 16px;
    border-top: 1px solid $light-gray-1;
  }
  &__item {
    display: flex;
    position: relative;
    width: 100%;
    column-gap: 16px;

    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
  &__item-content {
    padding: 15.5px 16px;
    background-color: #f4f5f7;
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: 0%;
    flex: 1 1 calc(100% - 16px - 24px);
  }
  &__item-actions {
    width: 24px;
    height: 24px;
    flex: 1 1 24px;
    cursor: pointer;
  }

  &__item-actions-icon {
    display: block;
    margin-top: 12px;
  }
  &__actions-dropdown {
    position: absolute;
    right: 0px;
    bottom: -72px;
    z-index: +5;
    padding: 8px 12px;
    width: 174px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 2px 4px 24px 0px rgba(0, 0, 0, 0.12);
  }
  &__action-edit {
    display: flex;
    align-items: center;
    height: 32px;
    margin-bottom: 8px;
    column-gap: 4px;
    cursor: pointer;
  }
  &__action-delete {
    display: flex;
    align-items: center;
    height: 32px;
    column-gap: 4px;
    cursor: pointer;
  }
  &__modal-delete {
    &::v-deep(.modal__body) {
      width: 360px;
      height: auto;
      border-radius: 16px;
    }
  }
  &__modal-poups {
    &::v-deep(.modal__body) {
      width: auto;
      height: auto;
      border-radius: 16px;
    }
  }
  &__input {
    width: 100%;
  }
}
</style>
